import formatNumber from '@arsenal/arsenal/modules/formatNumber'
import classNames from 'classnames'
import React from 'react'

interface IDigg {
  count: number
  digged: boolean
  className?: string
  onDigg: () => void
  onDiggCancel: () => void
  showCount?: boolean
  static?: boolean
}

const thumb_up_icon = require('static/digg.png')
const thumb_up_active_icon = require('static/digged.png')

export default function Digg(props: IDigg) {
  const {
    count,
    digged,
    className,
    onDigg,
    onDiggCancel,
    showCount,
    static: isStatic,
  } = props
  const handleClick = () => {
    if (digged) {
      onDiggCancel()
    } else {
      onDigg()
    }
  }
  return (
    <div className={classNames(className, 'container')}>
      {!isStatic ? (
        <>
          <img
            src={digged ? thumb_up_active_icon : thumb_up_icon}
            onClick={handleClick}
          />
          <span>{showCount ? formatNumber(count) : '点赞'}</span>
        </>
      ) : (
        showCount && <span>{formatNumber(count)} 点赞</span>
      )}

      <style jsx>
        {`
          .container {
            display: flex;
            align-items: center;
          }
          img {
            object-fit: cover;
            object-position: center;
            width: 18px;
            height: 18px;
            margin-right: 4px;
            cursor: pointer;
          }
          span {
            color: #1f2129;
            font-size: 12px;
            line-height: 1;
          }
        `}
      </style>
    </div>
  )
}
